module.exports = {"sitebuilder_templates":{"HERO_PANEL_HEADING":"Welcome to SiteBlocks","HERO_PANEL_BODY":"Bravenet's Brand New Website Builder<br>Please select a starting theme...","HERO_PANEL_CTA":"Get Started","HERO_PANEL_IMG_ALT":"Bravenet Site Builder","THEME_GARDEN_HEADING":"Turning Dreams into Success One Template at a Time","THEME_GARDEN_SUBHEADING":"To get started, choose from our professionally designed SiteBlocks templates.","THEME_GARDEN_ACTION_PREVIEW":"Preview Theme","THEME_GARDEN_ACTION_USE":"Use Theme"}}


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/i18n/sitebuilder/templates/en.json
// module id = /q/f
// module chunks = 0